import { render } from "./TrustpilotScore.vue?vue&type=template&id=3c91bd98"
import script from "./TrustpilotScore.vue?vue&type=script&lang=js"
export * from "./TrustpilotScore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/christianbundgaard/dev/cbundgaard-bitbucket/artivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__